export const useIntegrationsStore = defineStore('integrations', () => {
  const api = useApi()

  const count = ref(0)
  const integrations = ref<Integration[]>([])
  const integrationsForTeam = ref<Integration[]>([])
  const lastPage = ref(0)
  const nextPage = ref(1)

  const createIntegrationSettings = async (params: {
    apiKey: string
    integrationId: number
  }) => {
    try {
      const { data: integration } = await api.integrations.settings.create(params.integrationId, { apiKey: params.apiKey })

      addOrReplaceIntegrations({ integrations: [integration] })
      addOrReplaceIntegrationsForTeam({ integrations: [integration] })
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  const fetchIntegrations = async (params: {
    categories?: IntegrationCategories[]
    page?: number
    size?: number
    teamOnly?: boolean
  }) => {
    try {
      const response = await api.integrations.fetch({
        categories: params.categories,
        page: params.page,
        size: params.size,
        teamOnly: params.teamOnly,
      })

      if (params.teamOnly) {
        integrationsForTeam.value = response.data.integrations
      }
      else {
        count.value = response.data.meta.total
        lastPage.value = response.data.meta.lastPage
        nextPage.value = params.page && params.page >= response.data.meta.lastPage ? -1 : (params.page || 1) + 1

        addOrReplaceIntegrations({ integrations: response.data.integrations })
      }
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  const removeIntegrationSettings = async (params: {
    integrationId: number
    integrationSettingsId: number
  }) => {
    try {
      const { data: integration } = await api.integrations.settings.delete(params.integrationId, params.integrationSettingsId)

      addOrReplaceIntegrations({ integrations: [integration] })
      removeIntegrationsForTeam({ integrations: [integration] })
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  const updateIntegrationSettings = async (params: {
    apiKey: string
    integrationId: number
    integrationSettingsId: number
  }) => {
    try {
      const { data: integration } = await api.integrations.settings.update(params.integrationId, params.integrationSettingsId, { apiKey: params.apiKey })

      addOrReplaceIntegrations({ integrations: [integration] })
      addOrReplaceIntegrationsForTeam({ integrations: [integration] })
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  // Setters
  const addOrReplaceIntegrations = (params: {
    integrations: Integration[]
  }) => {
    for (const integration of params.integrations) {
      const index = integrations.value.findIndex((item) => {
        return item.id === integration.id
      })

      index === -1
        ? integrations.value.push(integration)
        : integrations.value.splice(index, 1, integration)
    }
  }

  const addOrReplaceIntegrationsForTeam = (params: {
    integrations: Integration[]
  }) => {
    for (const integration of params.integrations) {
      const index = integrationsForTeam.value.findIndex((item) => {
        return item.id === integration.id
      })

      index === -1
        ? integrationsForTeam.value.push(integration)
        : integrationsForTeam.value.splice(index, 1, integration)
    }
  }

  const removeIntegrationsForTeam = (params: {
    integrations: Integration[]
  }) => {
    for (const integration of params.integrations) {
      const index = integrationsForTeam.value.findIndex((item) => {
        return item.id === integration.id
      })

      if (index !== -1) {
        integrationsForTeam.value.splice(index, 1)
      }
    }
  }

  const resetIntegrations = () => {
    count.value = 0
    integrations.value = []
    lastPage.value = 0
    nextPage.value = 1
  }

  const resetStore = () => {
    count.value = 0
    integrations.value = []
    integrationsForTeam.value = []
    lastPage.value = 0
    nextPage.value = 1
  }

  return {
    addOrReplaceIntegrations,
    addOrReplaceIntegrationsForTeam,
    count,
    createIntegrationSettings,
    fetchIntegrations,
    integrations,
    integrationsForTeam,
    lastPage,
    nextPage,
    removeIntegrationSettings,
    removeIntegrationsForTeam,
    resetIntegrations,
    resetStore,
    updateIntegrationSettings,
  }
})
